/* tol-hero.js — TOL ヒーロースライダー（S13 新設 → ds04-#16 で送りのエンジンを置き換え・DECISIONS 2026-10-21（3））
 *
 * 形態（凍結 top_c_mobile_clean.html L766-819 の視覚意図）: 複数枚見えるカードのカルーセル・
 * 切れ目のない同じ向きの無限ループ・自動再生・PC は画像中心の矢印・ドット。
 *
 * ★エンジン（2026-10-21（3））: 送りは track の transform（translateX・px）で行い、ブラウザの
 * スクロールに位置を決めさせない。旧エンジン（ネイティブ横スクロール＋scroll-snap mandatory＋
 * scrollLeft の書き換え）は「mandatory は止まる位置を決めるだけで移動量を制限しない＝勢いよく
 * 払うと何枚も進む」「ループの瞬間移動がブラウザしだいで逆走・空白に見える」を作りで防げなかった。
 * 型は assets/tol-announcement.js（R4）を写す（完了検知は setTimeout だけ・瞬間移動は jump() 1 か所・
 * 確定ドラッグ以後の退出は endDrag() に合流）。ライブラリは使わない。
 *
 * ★DOM は Liquid のまま（.tol-hero__inner > .tol-hero__track > スライド）。track 自体を動かし、
 * 動かない inner で切り抜く。エンジンの前提になる指定（inner の overflow clip と touch-action、
 * track の overflow visible・snap なし・mask なし）は **この JS が inline で立てる**＝GitHub から
 * テーマへの反映がファイルごとに入り、CSS が古いまま新しい JS が動く数秒間でも崩れない。
 * JS が動く前（と動かなかったとき）は CSS どおりの素の横スクロールで全部見える。
 *
 * ★幾何（毎回 DOM から実測）: V = inner の幅、padL = track の padding-left、s = スライド幅、
 *   step = 2 枚目の左 − 1 枚目の左、d = (V − s)/2 − padL（1 枚目を中央に置くずれ）。
 *   k = round(d / step) = 静止時に中央へ来る slot の「現在」からのずれ（SP は常に 0・PC の 1029px
 *   以上は 1＝中央は 2 枚目でドットは 1 番。S13b の意図的な peek 構図をそのまま保つ）。
 *   物理位置 p の transform = tx(p) = d − (p + k) × step。
 *
 * ★状態機械（推測で埋めないための定義）
 *   phys    : 物理位置（slot 番号）。静止時は 0..N−1。例外はキーボードの保留（下）だけで −1。
 *   logical : ドットと a11y の現在＝((phys mod N) + N) mod N。
 *   phase   : 'idle' | 'animating' | 'dragging'
 *   moveSeq : 古い完了タイマーを無効にする単調増加の番号。
 *   不変条件: 見た目の位置と目標は、正規化の後どちらも p で [−1, N] の中。複製の枚数（H・T）は
 *             この範囲を、移動中・ドラッグ中も窓が覆われるように実測から決める。
 *   矢印・ドット・自動再生・キーボードは、移動中なら finalizePending()（目標へ瞬間移動で確定→正規化）
 *   してから次へ進む。目標を基準に途中から引き継ぐ形は採らない（連打で目標と見た目の差が積もり、
 *   正規化で見た目が複製の外へ飛ぶ＝空白）。指だけは、横の操作と確定した時点で今の見た目のまま
 *   止め、いちばん近いスライドを基準にする（ずれ ≤ 0.5 枚）。
 *
 * 複製は全部原本の後ろへ append し、左側（slot −H..−1）に見せる分は 1 枚ずつ inline の translateX で
 * 表示位置だけ移す＝原本のレイアウト位置は一切動かない（先頭へ挿入すると CLS に数えられうる）。
 *
 * custom element は作らない（アロー IIFE + data-*-init ガード・Dawn 本体無改修・tol- 隔離）。
 */
(() => {
  /* 同一 src の <script> はセクション複数配置で複数回実行される（フェッチは1回・実行はタグごと）。
     hero 単位は data-tol-hero-init で冪等だが、document レベルのリスナー多重登録を防ぐ */
  if (window.__tolHeroLoaded) return;
  window.__tolHeroLoaded = true;

  /* 完了待ちの長さは CSS の computed transition を読む（R4 決定 3・写しを持たない）。
     読めない環境だけ 450ms。CSS が古く transition が無いときは 0＝アニメなしで送る */
  const FALLBACK_SLIDE_MS = 450;
  const SETTLE_SAFETY_MS = 120;
  /* 横と縦の振り分け・ドラッグ確定・クリック抑止を同じしきい値にする（R4 と同じ 10px） */
  const DRAG_THRESHOLD = 10;
  /* 遅いドラッグはスライド間隔の 20% で送る（R4・2026-08-03 決定 6① と同じ値） */
  const COMMIT_RATIO = 0.2;
  /* 速さの判定は離す直前 100ms の速度。R4 の「開始から 250ms 以内」と違い、ゆっくり引いてから
     速く払う・途中で戻す、を区別できる（カードが大きいヒーロー向け・2026-10-21（3）） */
  const FLICK_VELOCITY = 0.3; /* px/ms */
  const VELOCITY_WINDOW_MS = 100;
  /* 横ホイール（トラックパッド）: 累積 30px で 1 枚。最後のイベントから 200ms 途切れるまで次を
     受けない＝慣性の尾で 2 枚目に行かない（1 ジェスチャー 1 枚） */
  const WHEEL_THRESHOLD = 30;
  const WHEEL_IDLE_MS = 200;
  /* マウスの mousedown でもリンクにフォーカスが来る（Chrome）。直前に押していればキーボード由来でない */
  const POINTER_FOCUS_GUARD_MS = 500;
  /* 見えている画像の読み込みを待つ上限（その後に両隣・残りを eager にする） */
  const IMAGE_WAIT_MS = 3000;

  const mq = (query) => {
    try {
      return window.matchMedia(query);
    } catch (_) {
      return null;
    }
  };
  /* Safari ≤13 は MediaQueryList.addEventListener 非対応＝addListener へ（R4 と同じ・S13 の init 中断の解消） */
  const onMqChange = (list, fn, signal) => {
    if (!list) return;
    try {
      list.addEventListener('change', fn, { signal });
    } catch (_) {
      try {
        list.addListener(fn);
        if (signal) {
          signal.addEventListener('abort', () => {
            try {
              list.removeListener(fn);
            } catch (_) {}
          });
        }
      } catch (_) {
        /* 監視できない環境では初期値のみで動く（劣化受容） */
      }
    }
  };

  const reduced = mq('(prefers-reduced-motion: reduce)');
  /* タッチ端末では tap の emulated mouseenter に mouseleave が来ず hover が固着しうる
     （S13 の既知事項）。hover 由来の停止は hover できる端末だけ（R4 決定 9 と同じ） */
  const hoverCapable = mq('(hover: hover) and (pointer: fine)');
  const hoverMatters = () => !hoverCapable || hoverCapable.matches;

  /* transition-duration / delay のリストの最大値（ms）。R4 と同じ（先頭だけ見ると
     「0s, 450ms」で同期パスを誤選択し、delay を無視すると遷移途中に settle する） */
  const maxTimeMs = (value, floorAtZero) => {
    let max = -1;
    String(value || '')
      .split(',')
      .forEach((part) => {
        const raw = part.trim();
        let ms = NaN;
        if (raw.endsWith('ms')) ms = parseFloat(raw);
        else if (raw.endsWith('s')) ms = parseFloat(raw) * 1000;
        if (!Number.isFinite(ms)) return;
        if (floorAtZero && ms < 0) ms = 0;
        if (ms > max) max = ms;
      });
    return max;
  };

  /* 1 インスタンス分の初期化。throw しても呼び出し側で teardown し、素の横スクロールに戻す */
  const initHero = (hero) => {
    if (hero.dataset.tolHeroInit) return;
    const inner = hero.querySelector('.tol-hero__inner');
    const track = hero.querySelector('[data-tol-hero-track]');
    const originals = track ? [...track.querySelectorAll('[data-tol-hero-slide]')] : [];
    if (!inner || !track || originals.length === 0) return;
    hero.dataset.tolHeroInit = 'true';

    const N = originals.length;
    const designMode = !!(window.Shopify && window.Shopify.designMode);
    const abort = new AbortController();
    const signal = abort.signal;
    const dots = [...hero.querySelectorAll('.tol-hero__dot')];
    const prevArrow = hero.querySelector('[data-tol-hero-prev]');
    const nextArrow = hero.querySelector('[data-tol-hero-next]');
    const speed = parseInt(hero.dataset.speed, 10) || 5000;

    /* geo.mode: 'loop'（はみ出す・storefront）| 'edit'（はみ出す・テーマエディター＝複製なしの左寄せ）|
       'static'（全部が収まる・1 枚） */
    let geo = null;
    let clones = [];
    let imagesWarm = false;
    let clickSuppress = false;
    let lastPointerDownAt = -Infinity;
    let ro = null;
    const state = {
      phys: 0,
      tx: 0, /* 今 inline に書いてある translateX（px） */
      editTx: 0, /* edit の位置（px・[−maxShift, 0]） */
      phase: 'idle',
      moveSeq: 0,
      timer: null,
      settleTimer: null,
      hold: null, /* キーボードで見せた原本（これにフォーカスがある間は正規化しない） */
    };
    const pauseReasons = new Set();
    const drag = {
      active: false,
      moved: false,
      pointerId: null,
      startX: 0,
      startY: 0,
      originX: 0, /* 横と確定した時点の指の位置＝表示の起点（つかんだ瞬間に跳ねない） */
      dx: 0, /* 表示用: 確定時点からの移動量 */
      travel: 0, /* 判定用: pointerdown からの移動量（止めたずれ f は入れない） */
      base: 0, /* loop: 基準の物理位置 / edit: 基準の位置（px） */
      f: 0, /* loop: 止めた見た目と基準の静止位置の差（px・判定には使わない） */
      samples: [],
      raf: 0,
    };
    const wheel = { acc: 0, locked: false, timer: null };

    const stopTimer = () => {
      if (state.timer) clearInterval(state.timer);
      state.timer = null;
    };
    const clearSettleTimer = () => {
      if (state.settleTimer) clearTimeout(state.settleTimer);
      state.settleTimer = null;
    };
    const removeClones = () => {
      clones.forEach((el) => el.remove());
      clones = [];
    };
    const releaseCapture = () => {
      try {
        if (drag.pointerId !== null && inner.hasPointerCapture && inner.hasPointerCapture(drag.pointerId)) {
          inner.releasePointerCapture(drag.pointerId);
        }
      } catch (_) {}
    };
    /* teardown（エディタのセクション削除/再レンダ・初期化の失敗）。JS 前の素の横スクロールへ戻す。
       途中で throw しても呼べるよう、参照する変数は全部この上で宣言済み */
    const teardown = () => {
      abort.abort();
      stopTimer();
      clearSettleTimer();
      if (wheel.timer) clearTimeout(wheel.timer);
      if (drag.raf) cancelAnimationFrame(drag.raf);
      if (ro) ro.disconnect();
      releaseCapture();
      removeClones();
      ['transform', 'transition', 'overflow', 'scroll-snap-type', 'mask-image', '-webkit-mask-image'].forEach((p) =>
        track.style.removeProperty(p)
      );
      ['overflow', 'touch-action'].forEach((p) => inner.style.removeProperty(p));
      inner.removeAttribute('data-tol-hero-engine');
      track.querySelectorAll('[data-tol-hero-nodrag]').forEach((el) => {
        el.removeAttribute('draggable');
        el.removeAttribute('data-tol-hero-nodrag');
      });
      hero.classList.remove('tol-hero--ready', 'tol-hero--static', 'tol-hero--dragging');
      delete hero.dataset.tolHeroInit;
    };
    hero._tolHero = { abort: teardown };

    /* ---- 幾何 ---- */
    const logicalOf = (p) => ((p % N) + N) % N;
    const measure = () => {
      const V = inner.clientWidth;
      const r0 = originals[0].getBoundingClientRect();
      const s = r0.width;
      if (V <= 0 || s <= 0) return null;
      const cs = getComputedStyle(track);
      const padL = parseFloat(cs.paddingLeft) || 0;
      const padR = parseFloat(cs.paddingRight) || 0;
      /* step は原本どうしの実測（同じ transform の下なので差は transform に依らない） */
      const step = N > 1 ? originals[1].getBoundingClientRect().left - r0.left : s + (parseFloat(cs.columnGap) || 0);
      if (!(step > 0)) return null;
      const contentW = track.clientWidth - padL - padR;
      const total = N * s + (N - 1) * (step - s);
      /* 今と同じ判定（旧 needsLoop の scrollWidth > clientWidth + 1）。resize で切り替える */
      const fits = N < 2 || total <= contentW + 1;
      const mode = fits ? 'static' : designMode ? 'edit' : 'loop';
      const d = (V - s) / 2 - padL;
      const k = mode === 'loop' ? Math.round(d / step) : 0;
      /* 見た目の位置は p で [−1, N]＝slot で [k−1, N+k]。窓に掛かるのは中央から ±Q slot */
      const Q = (V + s) / (2 * step);
      const H = mode === 'loop' ? Math.max(0, -Math.floor(k - 1 - Q)) : 0;
      const T = mode === 'loop' ? Math.max(0, Math.ceil(N + k + Q) - (N - 1)) : 0;
      return { mode, V, s, step, d, k, H, T, maxShift: Math.max(0, total - contentW) };
    };
    /* 丸めない＝どのスライドも静止位置が JS 前の位置（padL + d）とぴったり重なる。画素の格子へ丸めた版では
       JS 前（61.15px）と静止位置（61.07px）が食い違い、自動再生で後から窓に入ったスライドが LCP の候補として
       「わずかに大きい」と数えられ、LCP が 1 枚目の 15 秒から 45 秒へ更新された（DEV・390px・低速回線で実測。
       丸めない版は 88 秒まで 1 枚目のまま・2026-10-21（3）） */
    const txFor = (p) => geo.d - (p + geo.k) * geo.step;
    const clampEdit = (x) => Math.max(-geo.maxShift, Math.min(0, x));

    /* ---- transform ---- */
    const setTx = (x) => {
      state.tx = x;
      track.style.transform = `translateX(${x}px)`;
    };
    /* 唯一の「瞬間移動」。同期・同一タスク内で完結させる（R4 jump() と同じ） */
    const jumpTo = (x) => {
      track.style.transition = 'none';
      setTx(x);
      void track.offsetWidth; /* 強制 reflow: transition なしの新値をここで確定させる */
      track.style.removeProperty('transition'); /* CSS の値へ返す（duration は書かない） */
    };
    const visualTx = () => {
      const m = getComputedStyle(track).transform;
      if (!m || m === 'none') return state.tx;
      try {
        return new DOMMatrixReadOnly(m).m41;
      } catch (_) {
        return state.tx;
      }
    };

    /* ---- 複製（storefront の loop だけ） ---- */
    const makeClone = (slot) => {
      const src = originals[logicalOf(slot)];
      const clone = src.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.setAttribute('draggable', 'false');
      /* マーカーを外す＝再 init しても原本の集合が複製で汚れない。元の番号は検証用に残す */
      clone.removeAttribute('data-tol-hero-slide');
      clone.setAttribute('data-tol-hero-clone', String(logicalOf(slot)));
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
      clone.querySelectorAll('img').forEach((img) => {
        /* LCP の二重取得を防ぐ（1 枚目の複製に high を持ち込まない）。温め終わった後の作り直しは eager */
        img.loading = imagesWarm ? 'eager' : 'lazy';
        img.removeAttribute('fetchpriority');
        img.setAttribute('draggable', 'false');
      });
      clone._tolSlot = slot;
      return clone;
    };
    /* head（slot < 0）は DOM では末尾にあるので、表示位置だけ左へ移す */
    const positionClones = () => {
      const base = N + geo.T + geo.H; /* head の DOM 上の位置 m = slot + base */
      clones.forEach((clone) => {
        if (clone._tolSlot < 0) clone.style.transform = `translateX(${-base * geo.step}px)`;
      });
    };
    const buildClones = () => {
      removeClones();
      const frag = document.createDocumentFragment();
      for (let slot = N; slot < N + geo.T; slot += 1) clones.push(frag.appendChild(makeClone(slot)));
      for (let slot = -geo.H; slot < 0; slot += 1) clones.push(frag.appendChild(makeClone(slot)));
      track.appendChild(frag);
      positionClones();
    };

    /* ---- ドット（is-active + aria-current） ---- */
    const currentIndex = () => {
      if (!geo || geo.mode === 'static') return 0;
      if (geo.mode === 'edit') return Math.max(0, Math.min(N - 1, Math.round(-state.editTx / geo.step)));
      return logicalOf(state.phys);
    };
    const syncDots = (ci) => {
      dots.forEach((d, idx) => {
        d.classList.toggle('is-active', idx === ci);
        if (idx === ci) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    };

    /* ---- 自動再生（停止理由 Set: 全理由解消時のみ再開） ---- */
    const autoplayOk = () =>
      hero.dataset.autoplay === 'true' &&
      !!geo &&
      geo.mode === 'loop' &&
      !designMode &&
      !(reduced && reduced.matches) &&
      !document.hidden &&
      hero.isConnected &&
      !(hoverMatters() && hero.matches(':hover')) &&
      pauseReasons.size === 0;
    const restart = () => {
      stopTimer();
      if (autoplayOk()) state.timer = setInterval(() => {
        if (state.phase === 'dragging' || !autoplayOk()) return; /* skip はスケジュールを解除しない（R4） */
        go(1);
      }, speed);
    };
    const pause = (reason) => {
      pauseReasons.add(reason);
      stopTimer();
    };
    const resume = (reason) => {
      pauseReasons.delete(reason);
      restart(); /* 離れたら必ずフル間隔から */
    };

    /* ---- 送り ---- */
    const cssDurationMs = () => {
      const cs = getComputedStyle(track);
      const d = maxTimeMs(cs.transitionDuration, false);
      if (d < 0) return FALLBACK_SLIDE_MS;
      const delay = maxTimeMs(cs.transitionDelay, true);
      return d + (delay > 0 ? delay : 0);
    };
    const canAnimate = () => !(reduced && reduced.matches) && cssDurationMs() > 0;

    /* 正規化: phys が 0..N−1 の外なら N を足し引きして瞬間移動（複製と原本は同じ見た目）。
       force でないときは、キーボードで見せた原本にフォーカスがある間は保留する */
    const normalize = (force) => {
      if (!geo || geo.mode !== 'loop') {
        state.hold = null;
        return;
      }
      if (state.phys >= 0 && state.phys <= N - 1) {
        if (force) state.hold = null;
        return;
      }
      if (!force && state.hold) return;
      state.hold = null;
      state.phys = logicalOf(state.phys);
      jumpTo(txFor(state.phys));
    };
    const settle = (seq) => {
      if (seq !== state.moveSeq) return;
      clearSettleTimer();
      state.phase = 'idle';
      normalize(false);
      /* 自動再生が回っている最中は位相を乱さない（手動の経路は呼び出し側で restart する） */
      if (!state.timer) restart();
    };
    /* 走っている送りを目標で止めるだけ（正規化しない） */
    const stopAtTarget = () => {
      if (state.phase === 'animating') {
        state.moveSeq += 1;
        clearSettleTimer();
        jumpTo(state.tx);
        state.phase = 'idle';
      }
    };
    /* 進行中の送りを目標で確定して正規化する（入力ロックもキューも持たない＝R4 決定 4）。
       keepHold: 非表示タブ・reduced-motion の切替・bfcache 復帰・resize の経路。キーボードで見せた原本に
       フォーカスが残っている間の保留（p = −1）を解かない（解くと原本が窓の外へ出る＝Codex 実 diff レビュー P2） */
    const finalizePending = (keepHold) => {
      stopAtTarget();
      normalize(!keepHold);
    };
    /* 完了は setTimeout だけ（transitionend は move に帰属できない＝R4 決定 3） */
    const moveTx = (x) => {
      state.moveSeq += 1;
      const seq = state.moveSeq;
      clearSettleTimer();
      if (!canAnimate() || Math.abs(x - visualTx()) < 0.5) {
        jumpTo(x);
        settle(seq);
        return;
      }
      state.phase = 'animating';
      setTx(x);
      state.settleTimer = setTimeout(() => settle(seq), cssDurationMs() + SETTLE_SAFETY_MS);
    };
    const slideTo = (p) => {
      state.phys = p;
      syncDots(logicalOf(p));
      moveTx(txFor(p));
    };
    const editTo = (x) => {
      state.editTx = clampEdit(x);
      syncDots(currentIndex());
      moveTx(state.editTx);
    };
    const go = (dir) => {
      if (!geo || geo.mode === 'static') return;
      finalizePending(); /* ここを通るので送りの開始位置は常に 0..N−1 */
      if (geo.mode === 'loop') slideTo(state.phys + dir);
      else editTo(state.editTx - dir * geo.step); /* edit は今の実際の位置から ±step（端の空振りを避ける） */
    };
    const goToIndex = (i, instant) => {
      if (!geo || geo.mode === 'static') return;
      finalizePending();
      if (geo.mode === 'loop') {
        if (instant) {
          state.moveSeq += 1;
          state.phys = i;
          syncDots(i);
          jumpTo(txFor(i));
        } else slideTo(i); /* 周回の近道は取らない（今と同じ） */
      } else if (instant) {
        state.moveSeq += 1;
        state.editTx = clampEdit(-i * geo.step);
        syncDots(currentIndex());
        jumpTo(state.editTx);
      } else editTo(-i * geo.step);
    };

    /* ---- ドラッグ / スワイプ ---- */
    const dragDisplayTx = () => {
      if (geo.mode === 'loop') {
        const off = Math.max(-geo.step, Math.min(geo.step, drag.f + drag.dx)); /* 基準から ±1 枚 */
        return txFor(drag.base) + off;
      }
      return clampEdit(drag.base + drag.dx);
    };
    /* 横と確定した時点で、走っている送りを今の見た目で止め、基準を決める */
    const freezeForDrag = () => {
      let cur = state.phase === 'animating' ? visualTx() : state.tx;
      state.moveSeq += 1;
      clearSettleTimer();
      state.phase = 'dragging';
      state.hold = null;
      track.style.transition = 'none';
      if (geo.mode === 'loop') {
        let base = Math.round((geo.d - cur) / geo.step - geo.k); /* いちばん近いスライド */
        const shift = base - logicalOf(base); /* N の倍数 */
        base -= shift;
        cur += shift * geo.step; /* tx(p − mN) = tx(p) + mN·step＝見た目は同じ */
        state.phys = base;
        drag.base = base;
        drag.f = cur - txFor(base);
      } else {
        drag.base = cur;
        drag.f = 0;
      }
      setTx(cur);
    };
    const velocity = () => {
      const now = performance.now();
      const recent = drag.samples.filter((smp) => now - smp.t <= VELOCITY_WINDOW_MS);
      if (recent.length < 2) return 0;
      const a = recent[0];
      const b = recent[recent.length - 1];
      return b.t > a.t ? (b.x - a.x) / (b.t - a.t) : 0;
    };
    /* 結果は −1 / 0 / +1 だけ＝1 スワイプ 1 枚。判定は pointerdown からの指の移動量と速度だけ
       （止めたずれ f は入れない＝送りの途中でつかんでほぼ動かさずに離すと、最寄りへ戻る）。確定時点からの量で
       判定すると、イベントが粗いとき（しきい値を 1 回の移動で大きく越える）に越えた分を丸ごと取りこぼす（DEV で実測） */
    const decide = () => {
      const dx = drag.travel;
      const v = velocity();
      if (Math.abs(v) >= FLICK_VELOCITY) {
        if (Math.sign(v) !== Math.sign(dx)) return 0; /* 途中で戻した動き */
        return v < 0 ? 1 : -1;
      }
      if (Math.abs(dx) > geo.step * COMMIT_RATIO) return dx < 0 ? 1 : -1;
      return 0;
    };
    function trackPointer(e) {
      drag.dx = e.clientX - drag.originX;
      drag.travel = e.clientX - drag.startX;
      drag.samples.push({ t: performance.now(), x: e.clientX });
      if (drag.samples.length > 12) drag.samples.shift();
    }
    const onWinMove = (e) => {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      if (e.pointerType === 'mouse' && e.buttons === 0) {
        endDrag(false); /* up の取りこぼしで残った状態を hover 移動で誤確定させない */
        return;
      }
      if (!drag.moved) {
        const rx = e.clientX - drag.startX;
        const ry = e.clientY - drag.startY;
        if (Math.max(Math.abs(rx), Math.abs(ry)) < DRAG_THRESHOLD) return;
        if (Math.abs(rx) <= Math.abs(ry)) {
          /* 縦の操作: 帯は動かさず、走っている送りもそのまま（縦スクロールはブラウザ＝touch-action） */
          endDrag(false);
          return;
        }
        drag.moved = true;
        drag.originX = e.clientX;
        freezeForDrag();
        hero.classList.add('tol-hero--dragging');
        try {
          inner.setPointerCapture(drag.pointerId);
        } catch (_) {
          /* capture 失敗時は window リスナーで追従継続（劣化受容） */
        }
      }
      trackPointer(e);
      if (!drag.raf) {
        drag.raf = requestAnimationFrame(() => {
          drag.raf = 0;
          if (drag.active && drag.moved) setTx(dragDisplayTx());
        });
      }
    };
    const onWinUp = (e) => {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      if (drag.moved) trackPointer(e); /* 離した位置も数える */
      endDrag(true);
    };
    const onWinCancel = (e) => {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      /* 横と確定した後に来たら、それまでの移動量と速さで判定する（iOS Safari は横のスワイプの途中でも
         pointercancel を出すことがあり〔iPhone 実機で観測・移動量 −134〜−237px〕、基準へ戻すと「スワイプしても
         元の写真に戻る」になる）。cancel の座標は当てにならない（実機では縦が −325px など不自然な値で来た）ので記録に入れない。
         確定前（しきい値未満・ピンチの開始）は送らない */
      endDrag(drag.moved);
    };
    /* 確定ドラッグ以後の全退出経路の合流点（R4） */
    function endDrag(flush) {
      if (!drag.active) return;
      if (drag.raf) {
        cancelAnimationFrame(drag.raf);
        drag.raf = 0;
      }
      window.removeEventListener('pointermove', onWinMove);
      window.removeEventListener('pointerup', onWinUp);
      window.removeEventListener('pointercancel', onWinCancel);
      /* 判定と状態を先に取り出し、active を落としてから捕捉を外す（R4 と同じ順・解放で lostpointercapture が
         同期に来ても入れ子の endDrag にならない＝critical 実 diff レビュー MINOR-2） */
      const moved = drag.moved;
      const dir = moved && flush ? decide() : 0;
      drag.active = false;
      releaseCapture();
      drag.moved = false;
      drag.pointerId = null;
      drag.samples = [];
      hero.classList.remove('tol-hero--dragging');
      if (moved) {
        clickSuppress = true;
        /* click が来ないケースでフラグが残り、次の正当なクリック（矢印・ドットも inner の中）を食うのを防ぐ */
        setTimeout(() => {
          clickSuppress = false;
        }, 0);
        /* 最終位置を同期 flush → reflow → transition 復帰（この順でないと指の位置から飛ぶ） */
        setTx(dragDisplayTx());
        void track.offsetWidth;
        track.style.removeProperty('transition');
        state.phase = 'idle';
        if (geo.mode === 'loop') slideTo(drag.base + dir);
        else editTo(drag.base - dir * geo.step);
      }
      drag.dx = 0;
      drag.travel = 0;
      resume('pointer');
    }
    inner.addEventListener(
      'pointerdown',
      (e) => {
        lastPointerDownAt = performance.now();
        if (!e.isPrimary) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest && e.target.closest('.tol-hero__arrow, .tol-hero__dots')) return;
        if (!geo || geo.mode === 'static') return;
        if (drag.active) endDrag(false);
        drag.active = true;
        drag.moved = false;
        drag.pointerId = e.pointerId;
        drag.startX = e.clientX;
        drag.startY = e.clientY;
        drag.dx = 0;
        drag.travel = 0;
        /* 速度の起点に押した瞬間を入れる（1 回の大きな移動でも速さが出る） */
        drag.samples = [{ t: performance.now(), x: e.clientX }];
        pause('pointer');
        /* ここでは止めない（縦スクロールで触れただけで送りが止まり、戻しで逆向きに動くのを避ける）。
           preventDefault しない＝しきい値未満はクリックとして生きる */
        window.addEventListener('pointermove', onWinMove, { signal });
        window.addEventListener('pointerup', onWinUp, { signal });
        window.addEventListener('pointercancel', onWinCancel, { signal });
      },
      { signal }
    );
    inner.addEventListener(
      'lostpointercapture',
      (e) => {
        /* inner 自身が捕捉を失ったときだけ。タッチは押した要素（画像）に暗黙に捕捉され、確定時に
           setPointerCapture(inner) で移すと、画像側の lostpointercapture が inner まで伝わる＝それで
           終わらせるとタッチのスワイプが必ず取り消される（Codex 実 diff レビュー P1） */
        if (e.target !== inner || e.pointerId !== drag.pointerId) return;
        if (drag.active && drag.moved) endDrag(false);
      },
      { signal }
    );
    /* 横と確定した後の touchmove を止める＝iOS が縦スクロールとして引き取って pointercancel を出すのを防ぐ
       （touch-action: pan-y だけでは、途中で混ざる縦の動きで引き取られた＝iPhone 実機で観測）。確定前は何もしない
       ＝縦のスクロールは今のまま。passive: false は inner の上の touchmove だけ */
    inner.addEventListener(
      'touchmove',
      (e) => {
        if (drag.active && drag.moved && e.cancelable) e.preventDefault();
      },
      { passive: false, signal }
    );
    /* リンク・画像のネイティブドラッグが始まると pointer stream が死ぬ */
    inner.addEventListener(
      'dragstart',
      (e) => {
        if (drag.active) e.preventDefault();
      },
      { signal }
    );
    /* ドラッグ直後のリンク誤発火を capture で 1 回だけ止める */
    inner.addEventListener(
      'click',
      (e) => {
        if (!clickSuppress) return;
        e.preventDefault();
        e.stopPropagation();
        clickSuppress = false;
      },
      { capture: true, signal }
    );

    /* ---- 横ホイール（トラックパッド）: 旧エンジンは track がスクロール容器で横の 2 本指で送れ、
       ブラウザの「戻る」も起きなかった。clip にすると両方失われるので補う。縦が優勢のホイールは触らない ---- */
    inner.addEventListener(
      'wheel',
      (e) => {
        if (!geo || geo.mode === 'static' || drag.active) return;
        const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? inner.clientWidth : 1;
        const dx = e.deltaX * unit;
        const dy = e.deltaY * unit;
        if (Math.abs(dx) <= Math.abs(dy)) return;
        e.preventDefault();
        if (wheel.timer) clearTimeout(wheel.timer);
        wheel.timer = setTimeout(() => {
          wheel.locked = false;
          wheel.acc = 0;
        }, WHEEL_IDLE_MS);
        if (wheel.locked) return;
        wheel.acc += dx;
        if (Math.abs(wheel.acc) >= WHEEL_THRESHOLD) {
          const dir = wheel.acc > 0 ? 1 : -1;
          wheel.locked = true;
          wheel.acc = 0;
          go(dir);
          restart();
        }
      },
      { passive: false, signal }
    );

    /* ---- 矢印・ドット ---- */
    if (prevArrow)
      prevArrow.addEventListener(
        'click',
        () => {
          go(-1);
          restart();
        },
        { signal }
      );
    if (nextArrow)
      nextArrow.addEventListener(
        'click',
        () => {
          go(1);
          restart();
        },
        { signal }
      );
    dots.forEach((d, idx) =>
      d.addEventListener(
        'click',
        () => {
          goToIndex(idx, false);
          restart();
        },
        { signal }
      )
    );

    /* ---- 停止理由・キーボード ---- */
    hero.addEventListener(
      'mouseenter',
      () => {
        if (hoverMatters()) pause('hover');
      },
      { signal }
    );
    hero.addEventListener('mouseleave', () => resume('hover'), { signal });
    /* clip の窓は自動でスクロールしないので、キーボードで窓に収まっていない原本へフォーカスが
       移ったときだけ、そのカードが中央に来る位置（p = i − k）へ送る。マウス・タップのフォーカスでは
       動かさない（押している最中にカードが動くと click が成立しない） */
    hero.addEventListener(
      'focusin',
      (e) => {
        pause('focus');
        if (!geo || geo.mode === 'static' || drag.active) return;
        if (performance.now() - lastPointerDownAt < POINTER_FOCUS_GUARD_MS) return;
        const target = e.target;
        let keyboard = true;
        try {
          keyboard = target.matches(':focus-visible');
        } catch (_) {}
        if (!keyboard) return;
        const i = originals.findIndex((o) => o === target || o.contains(target));
        if (i < 0) return;
        const r = originals[i].getBoundingClientRect();
        const w = inner.getBoundingClientRect();
        if (r.left >= w.left - 0.5 && r.right <= w.right + 0.5) return;
        /* 正規化しない＝保留中（p = −1）から隣の原本へ移るときに、N−1 へ正規化してから N−1 枚逆向きに送るのを防ぐ
           （critical MINOR-1・DEV の 1045px で実測）。p は −1..N−2 で、複製の範囲内 */
        stopAtTarget();
        if (geo.mode === 'loop') {
          const p = i - geo.k;
          /* k=1 で先頭の原本なら p = −1。正規化すると中央が複製になり、フォーカスのある原本が窓の外へ
             出るので、フォーカスが離れるまで正規化を保留する（p = −1 は複製の範囲内） */
          state.hold = p < 0 || p > N - 1 ? originals[i] : null;
          slideTo(p);
        } else editTo(-i * geo.step);
      },
      { signal }
    );
    hero.addEventListener(
      'focusout',
      (e) => {
        if (state.hold && !state.hold.contains(e.relatedTarget)) {
          state.hold = null;
          /* ヒーローの中で移るとき（原本 0 → 1 の Tab）は正規化しない＝ここで N−1 へ移すと、次の focusin が
             窓の外と判断して N−1 枚逆向きに送る（critical MINOR-1）。p = −1 は複製の範囲内で、次の送り・
             ドラッグ・置き直しが正規化する */
          if (state.phase === 'idle' && !hero.contains(e.relatedTarget)) normalize(true);
        }
        if (!hero.contains(e.relatedTarget)) resume('focus');
      },
      { signal }
    );
    /* clip 非対応（Safari 15 以前）の overflow: hidden では窓がスクロールされうる＝0 に戻す */
    inner.addEventListener(
      'scroll',
      () => {
        if (inner.scrollLeft) inner.scrollLeft = 0;
      },
      { signal }
    );
    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) {
          /* 非表示の間は保留状態を残さない（背景タブではタイマーがクランプされる） */
          stopTimer();
          if (drag.active) endDrag(false);
          finalizePending(true);
        } else {
          if (geo && geo.mode === 'loop') jumpTo(txFor(state.phys)); /* べき等な自己正規化 */
          restart();
        }
      },
      { signal }
    );
    onMqChange(
      reduced,
      () => {
        finalizePending(true);
        restart();
      },
      signal
    );
    /* bfcache 復帰: 復元 DOM には複製と inline transform も含まれる。保留を巻き戻す */
    window.addEventListener(
      'pageshow',
      (e) => {
        if (!e.persisted) return;
        stopTimer();
        if (drag.active) endDrag(false);
        clickSuppress = false;
        finalizePending(true);
        restart();
      },
      { signal }
    );

    /* ---- 置き直し（resize・static と loop の切替）。ドラッグは必ず先に畳む ---- */
    const applyGeometry = (next) => {
      const prev = geo;
      geo = next;
      const rebuild = !prev || prev.mode !== next.mode || prev.H !== next.H || prev.T !== next.T || prev.k !== next.k;
      if (rebuild) {
        removeClones();
        if (next.mode === 'loop') buildClones();
      } else if (next.mode === 'loop') positionClones();
      hero.classList.toggle('tol-hero--static', next.mode === 'static');
      if (next.mode === 'loop') {
        const held = state.hold && state.hold.contains(document.activeElement) ? originals.indexOf(state.hold) : -1;
        if (held >= 0) {
          /* キーボードで見せた原本を、新しい k でも中央に置き直す */
          state.phys = held - next.k;
          if (state.phys >= 0 && state.phys <= N - 1) state.hold = null;
        } else {
          state.hold = null;
          state.phys = logicalOf(state.phys);
        }
        jumpTo(txFor(state.phys));
      } else if (next.mode === 'edit') {
        state.editTx = clampEdit(state.editTx);
        jumpTo(state.editTx);
      } else {
        state.phys = 0;
        jumpTo(0);
      }
      syncDots(currentIndex());
    };
    const relayout = () => {
      if (drag.active) endDrag(false);
      finalizePending(true);
      const next = measure();
      if (!next) return;
      applyGeometry(next);
      restart();
    };

    /* ---- 画像: 見えている画像 → 次に入る両隣 → 残り、の順に読ませる（送りは待たない） ---- */
    const slideImages = (pad) => {
      const w = inner.getBoundingClientRect();
      return [...originals, ...clones]
        .filter((el) => {
          const r = el.getBoundingClientRect();
          return r.right > w.left - pad && r.left < w.right + pad;
        })
        .flatMap((el) => [...el.querySelectorAll('img')]);
    };
    const waitImages = (imgs) =>
      new Promise((resolve) => {
        const pending = imgs.filter((img) => !img.complete);
        if (pending.length === 0) {
          resolve();
          return;
        }
        let left = pending.length;
        const timer = setTimeout(resolve, IMAGE_WAIT_MS);
        const done = () => {
          left -= 1;
          if (left <= 0) {
            clearTimeout(timer);
            resolve();
          }
        };
        pending.forEach((img) => {
          img.addEventListener('load', done, { once: true, signal });
          img.addEventListener('error', done, { once: true, signal });
        });
      });
    const toEager = (img) => {
      if (img.loading !== 'eager') img.loading = 'eager';
    };
    const warmImages = () => {
      waitImages(slideImages(0))
        .then(() => {
          if (signal.aborted || !geo) return null;
          const near = slideImages(geo.step);
          near.forEach(toEager);
          return waitImages(near);
        })
        .then(() => {
          if (signal.aborted) return;
          imagesWarm = true;
          [...originals, ...clones].forEach((el) => el.querySelectorAll('img').forEach(toEager));
        });
    };

    /* ---- init（1 タスク内で同期実行。--ready と transform を同じ style 再計算に入れない） ---- */
    /* JS 前に横スクロールされていたら、窓の中央に近い原本から始める（overflow を変えると scrollLeft は捨てられる） */
    const preScroll = track.scrollLeft;
    let startOriginal = 0;
    if (preScroll > 1) {
      const w = inner.getBoundingClientRect();
      const cx = w.left + w.width / 2;
      let best = Infinity;
      originals.forEach((o, i) => {
        const r = o.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - cx);
        if (dist < best) {
          best = dist;
          startOriginal = i;
        }
      });
    }
    /* エンジンの前提は inline（CSS が古いままでも崩れない・teardown で外す） */
    inner.style.overflow = 'clip';
    if (inner.style.overflow !== 'clip') inner.style.overflow = 'hidden';
    inner.style.touchAction = 'pan-y pinch-zoom';
    if (!inner.style.touchAction) inner.style.touchAction = 'pan-y';
    track.style.overflow = 'visible';
    track.style.scrollSnapType = 'none';
    /* 旧 CSS の mask は track にある＝track を動かすと箱の外（左へ出した複製）を消し、フェードも動く */
    track.style.setProperty('-webkit-mask-image', 'none');
    track.style.setProperty('mask-image', 'none');
    track.scrollLeft = 0;
    inner.scrollLeft = 0;
    inner.setAttribute('data-tol-hero-engine', '');
    /* 原本のリンクと画像のネイティブドラッグを止める（マウスで払うと 10px のしきい値より先に HTML5 の
       ドラッグが始まり、pointer の移動が来なくなる＝DEV で実測）。teardown で外す */
    originals.forEach((o) => {
      [o, ...o.querySelectorAll('img')].forEach((el) => {
        if (!el.hasAttribute('draggable')) {
          el.setAttribute('draggable', 'false');
          el.setAttribute('data-tol-hero-nodrag', '');
        }
      });
    });

    const first = measure();
    if (!first) throw new Error('tol-hero: zero-size layout');
    /* JS 前のスクロールを読み替えるときだけ k を引く（無ければ 0＝ドット 1。k を常に引くと PC で 5 枚目から始まる＝Codex P2） */
    if (first.mode === 'loop') state.phys = preScroll > 1 ? logicalOf(startOriginal - first.k) : 0;
    else if (first.mode === 'edit') state.editTx = Math.max(-first.maxShift, Math.min(0, -preScroll));
    track.style.transition = 'none';
    applyGeometry(first);
    track.style.transition = 'none';
    void track.offsetWidth;
    hero.classList.add('tol-hero--ready'); /* 矢印の表示・CSS の transition はここから */
    void track.offsetWidth;
    track.style.removeProperty('transition');

    if (typeof ResizeObserver === 'function') {
      /* callback の中で同期に置き直す（rAF に回すと 1 フレーム古い位置が描かれる） */
      ro = new ResizeObserver(() => {
        if (!geo) return;
        const V = inner.clientWidth;
        if (V === 0) {
          stopTimer();
          if (drag.active) endDrag(false);
          return;
        }
        if (Math.abs(V - geo.V) < 0.5 && Math.abs(originals[0].getBoundingClientRect().width - geo.s) < 0.5) {
          if (!state.timer) restart(); /* 幅 0（祖先が非表示）から同じ幅に戻ったとき */
          return;
        }
        relayout();
      });
      ro.observe(inner);
    }

    hero._tolHero = {
      abort: teardown,
      go,
      goToIndex,
      state,
      geometry: () => geo,
      select: (el) => {
        const i = originals.findIndex((o) => o === el || o.contains(el));
        if (i >= 0) goToIndex(i, true);
      },
    };
    restart();
    warmImages();
  };

  const init = (root) => {
    root.querySelectorAll('[data-tol-hero]').forEach((hero) => {
      try {
        initHero(hero);
      } catch (err) {
        /* 途中で失敗したら複製と inline 指定を外し、素の横スクロールに戻す（fail-closed） */
        if (hero._tolHero) hero._tolHero.abort();
        if (window.Shopify && window.Shopify.designMode && window.console) {
          console.warn('[tol-hero] init failed; hero stays as native scroll', err);
        }
      }
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-tol-hero]').forEach((hero) => {
      if (hero._tolHero) hero._tolHero.abort();
    });
  });
  /* エディタでブロック選択 → そのスライドの番号へ瞬間移動（エディターは複製なしの左寄せ） */
  document.addEventListener('shopify:block:select', (e) => {
    const hero = e.target.closest && e.target.closest('[data-tol-hero]');
    if (hero && hero._tolHero && hero._tolHero.select) hero._tolHero.select(e.target);
  });
})();
